import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color", "children", "content", "badgeClassName", "tagName", "offset", "activated", "size"];
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import React from 'react';
import { Badge } from "./Badge";
import styles from "./styles.pcss";
var cnBadgeWrapper = cnBem('badge-wrapper', styles);
export var BadgeWrapper = forwardRefWithTag(function (props, ref) {
  var _ref2;
  var className = props.className,
    color = props.color,
    children = props.children,
    content = props.content,
    badgeClassName = props.badgeClassName,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 4 : _props$offset,
    activated = props.activated,
    size = props.size,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  var _ref = typeof offset === 'number' ? {
      vertical: offset,
      horizontal: offset
    } : offset,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? 4 : _ref$vertical,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? 4 : _ref$horizontal;
  return /*#__PURE__*/React.createElement(Tag, _extends({}, otherProps, {
    className: cnBadgeWrapper(null, [className]),
    ref: ref,
    "data-t-id": "components-Badge"
  }), children, /*#__PURE__*/React.createElement(Badge, {
    activated: activated,
    className: cnBadgeWrapper('badge', [badgeClassName]),
    color: color,
    size: size,
    style: (_ref2 = {}, _defineProperty(_ref2, '--badge-offset-vertical', "".concat(vertical, "px")), _defineProperty(_ref2, '--badge-offset-horizontal', "".concat(horizontal, "px")), _ref2),
    "data-t-id": "components-Badge"
  }, content));
});